/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activate_On_Presence_TimeslotInputs */



/**
* | output |
* | --- |
* | "Enabled on presence schedule" |
*
* @param {Activate_On_Presence_TimeslotInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const activate_on_presence_timeslot = /** @type {((inputs?: Activate_On_Presence_TimeslotInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activate_On_Presence_TimeslotInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Enabled on presence schedule")
	return /** @type {LocalizedString} */ ("Activé sur planning de présence")
});